import { useSnackbar } from 'notistack';
import { useCallback } from 'react';

/**
 * Returns `copy(text)`, which writes to the clipboard and shows `copied` in
 * a snackbar, or `failed` when the browser refuses.
 */
export function useCopyToClipboard(
  copied: string,
  failed: string,
): (text: string) => Promise<void> {
  const { enqueueSnackbar } = useSnackbar();

  return useCallback(
    async (text: string) => {
      try {
        await navigator.clipboard.writeText(text);
        enqueueSnackbar(copied, { variant: 'info' });
      } catch {
        enqueueSnackbar(failed, { variant: 'error' });
      }
    },
    [copied, failed, enqueueSnackbar],
  );
}
